import React, { useState } from 'react'
import { Input, Grid, Row, Col, Panel, RadioGroup, Radio } from 'rsuite'
import { isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'

export default function RiskAssessmentForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isHaveDelayRisk, setIsHaveDelayRisk] = useState(_schema.isDelayEvaluated.value)
  const [isHaveFinancialRisk, setIsHaveFinancialRisk] = useState(_schema.isFinanceEvaluated.value)

  return (
    <Panel>
      <Grid fluid>
        <Row>{schema.delayRisk.label}</Row>
        <Row>
          <Controller
            key={schema.isDelayEvaluated.name}
            name={schema.isDelayEvaluated.name}
            control={control}
            defaultValue={schema.isDelayEvaluated.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  inline
                  onChange={(val) => {
                    props.onChange(val)

                    if (val == 0) {
                      setValue(schema.delayRisk.name, '')
                    }
                    setIsHaveDelayRisk(val)
                  }}
                >
                  {schema.isDelayEvaluated.options?.map((item) => {
                    return <Radio value={item.value}>{item.label}</Radio>
                  })}
                </RadioGroup>
              )
            }}
          />
        </Row>
        {isHaveDelayRisk == 1 && (
          <>
            {/* {errors[schema.delayRisk.name] && (
              <Row style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.delayRisk.name]} />
              </Row>
            )} */}
            <Row style={{ marginTop: 10 }}>
              <CKEditorFrom
                schema={schema.delayRisk}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              {/* <Input
                componentClass="textarea"
                rows={3}
                name={schema.delayRisk.name}
                defaultValue={schema.delayRisk.value}
                inputRef={register(isValidators(schema.delayRisk.validators))}
                placeholder={schema.delayRisk.hint}
              /> */}
            </Row>
          </>
        )}

        <Row style={{ marginTop: 10 }}>{schema.financialRisk.label}</Row>
        <Row>
          <Controller
            key={schema.isFinanceEvaluated.name}
            name={schema.isFinanceEvaluated.name}
            control={control}
            defaultValue={schema.isFinanceEvaluated.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  inline
                  onChange={(val) => {
                    props.onChange(val)
                    if (val == 0) {
                      setValue(schema.financialRisk.name, '')
                    }
                    setIsHaveFinancialRisk(val)
                  }}
                >
                  {schema.isFinanceEvaluated.options?.map((item) => {
                    return <Radio value={item.value}>{item.label}</Radio>
                  })}
                </RadioGroup>
              )
            }}
          />
        </Row>

        {isHaveFinancialRisk == 1 && (
          <>
            {/* {errors[schema.financialRisk.name] && (
              <Row style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.financialRisk.name]} />
              </Row>
            )} */}
            <Row style={{ marginTop: 10 }}>
              <CKEditorFrom
                schema={schema.financialRisk}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
              {/* <Input
                componentClass="textarea"
                rows={3}
                name={schema.financialRisk.name}
                defaultValue={schema.financialRisk.value}
                inputRef={register(isValidators(schema.financialRisk.validators))}
                placeholder={schema.financialRisk.hint}
              /> */}
            </Row>
          </>
        )}
      </Grid>
    </Panel>
  )
}
